module.exports = __webpack_public_path__ + "static/media/notifications.a8c87286.svg";